import { Typography } from '@mui/material';
import styled from 'styled-components';

export const CustomTypography = styled(Typography)`
  position: absolute;
  left: -9999px;
`;
